import React from 'react';
import BaseDealDetailDialog from '@/modules/deals/shared/components/BaseDealDetailDialog';
import { IconActionButton } from '@/shared/components/patterns';

const ProposalDetailDialog = ({
  proposal,
  isOpen,
  onClose,
  focusComments = false,
  onSave,
  onPromote,
  onDelete,
  promotionState = {},
  onOpenClient,
  onOpenStaff,
  staff,
  clients,
  canManageDealDestructiveActions = false,
}) => {
  const canPromote = proposal && !proposal.inProgressDealId;
  const canDelete =
    proposal &&
    !proposal.inProgressDealId &&
    proposal.stage === 'Posizioni da gestire' &&
    canManageDealDestructiveActions;

  return (
    <BaseDealDetailDialog focusComments={focusComments}
      deal={proposal}
      isOpen={isOpen}
      onClose={onClose}
      onSave={onSave}
      onOpenClient={onOpenClient}
      onOpenStaff={onOpenStaff}
      dealType="proposta"
      staff={staff}
      clients={clients}
      allowEditing={!promotionState.loading}
      allowTypeChange={false}
      primaryActions={canPromote ? (
        <IconActionButton
          iconKey="status.inProgress"
          label={promotionState.loading ? 'Promozione in corso' : 'Promuovi a In corso'}
          disabled={promotionState.loading}
          onClick={() => onPromote?.(proposal.id)}
        />
      ) : null}
      dangerActions={canDelete ? (
        <IconActionButton
          iconKey="actions.delete"
          label="Elimina proposta"
          tone="danger"
          disabled={promotionState.loading}
          onClick={() => onDelete?.(proposal.id)}
        />
      ) : null}
      extraContent={
        proposal ? (
          <>
            {!canPromote ? (
              <div className="entity-detail-dialog__notice" role="status">
                Proposta già promossa in In corso.
              </div>
            ) : null}
            {promotionState.error ? (
              <div className="entity-detail-dialog__notice deal-detail__error wt-inline-error" role="alert">
                {promotionState.error}
              </div>
            ) : null}
          </>
        ) : null
      }
    />
  );
};

export default ProposalDetailDialog;
